import { useState } from 'react';

import { DisplayComponent } from '@/components/DisplayComponent';
import { DisplayHeading } from '@/components/DisplayHeading';
import { Header } from '@/components/Header';
import { ProgressBar } from '@/components/ProgressBar';
import { useScreenCopy } from '@/copy';

import { AddressInformation } from './AddressInformation';
import { ContactDetails } from './ContactDetails';
import { OcrSummaryButtons } from './OcrSummaryButtons';
import { PersonalInformation } from './PersonalInformation';

export const testId = 'OcrSummary';

export function OcrSummary(): JSX.Element {
    const screenCopy = useScreenCopy('ocrSummary');
    // ***** Local State *****
    const [showErrors, setShowErrors] = useState(false);

    // ***** CONSTANTS *****
    const baseId = 'screen-OcrSummary';
    return (
        <div data-testid={testId}>
            <DisplayComponent baseId={baseId}>
                <Header />
                <ProgressBar />
                <DisplayHeading
                    title={screenCopy.title}
                    infoText={screenCopy.subtitle}
                />
                <ContactDetails baseId={baseId} showErrors={showErrors} />
                <AddressInformation baseId={baseId} showErrors={showErrors} />
                <PersonalInformation baseId={baseId} showErrors={showErrors} />
                <OcrSummaryButtons
                    baseId={baseId}
                    setShowErrors={setShowErrors}
                />
            </DisplayComponent>
        </div>
    );
}
